import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "position-relative d-flex align-items-center" };
const _hoisted_2 = { class: "border-0 bg-transparent" };
const _hoisted_3 = {
    key: 0,
    class: "notification-sign position-absolute"
};
const _hoisted_4 = { class: "px-3 pb-2 pt-2 gap-2 d-flex flex-wrap justify-content-between" };
const _hoisted_5 = { class: "d-flex gap-3" };
const _hoisted_6 = { class: "d-flex" };
const _hoisted_7 = {
    key: 0,
    class: "p-0 custom-sidebar m-0 overflow-y-auto"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = { class: "d-flex date-time-container align-items-end flex-column gap-1" };
const _hoisted_11 = { class: "mb-0 text-dark" };
const _hoisted_12 = { class: "mb-0 text-dark" };
const _hoisted_13 = {
    key: 1,
    class: "m-0 pb-2 text-dark px-3 empty-text-message"
};
import { computed, onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import NotificationSVG from '../CustomSVG/NotificationSVG.vue';
import { handleDisciplineFeedbackNavigation } from '@/utils/helpers';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotificationItems',
    props: {
        renderedInSidebar: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const router = useRouter();
        const screenWidth = computed(() => store.getters.getUserWidth);
        const notificationsData = computed(() => store.getters.getNotificationsData);
        const notificationPage = computed(() => store.getters.getNotificationPage);
        const activeSelectName = computed(() => store.getters.getSelectName);
        const unreadNotificationsAmount = computed(() => store.getters.getUnreadNotificationsAmount);
        const bellIcon = ref();
        const notificationListStyles = ref();
        const notificationListState = ref(false);
        const handleNotificationListState = () => {
            if (!notificationListState.value) {
                setTimeout(() => {
                    store.dispatch('setSelectData', { selectName: 'notificationList', selectWrapperDiv: '.notification-list' });
                    notificationListState.value = true;
                }, 0);
                return;
            }
            notificationListState.value = false;
        };
        const validateRequiredParamsForRoutment = (params) => {
            const paramsKeys = Object.keys(params);
            for (let i = 0; i < paramsKeys.length; i++) {
                if (!params[paramsKeys[i]]) {
                    store.dispatch('toastfy/activeErrorNotification', { text: "Esse item não está mais disponível" });
                    return false;
                }
            }
            return true;
        };
        const handleNotificationAction = (notificationData) => {
            if (!notificationData.read_at) {
                markNotificationAsRead(notificationData.id, null);
            }
            const notificationType = notificationData.type;
            switch (notificationType) {
                case 'MaterialItemCreated':
                    const materalItemRoutmentParams = { id: notificationData?.discipline_id };
                    if (!validateRequiredParamsForRoutment(materalItemRoutmentParams))
                        return;
                    router.push({ name: 'Discipline Material', params: materalItemRoutmentParams });
                    break;
                case 'MaterialCreated':
                    const materialRoutmentParams = { id: notificationData?.discipline_id };
                    if (!validateRequiredParamsForRoutment(materialRoutmentParams))
                        return;
                    router.push({ name: 'Discipline Material', params: materialRoutmentParams });
                    break;
                case 'ForumCreated':
                    const forumRoutmentParams = { disciplineId: notificationData?.discipline_id, forumId: notificationData?.subject_id };
                    if (!validateRequiredParamsForRoutment(forumRoutmentParams))
                        return;
                    router.push({ name: 'Forum View', params: forumRoutmentParams });
                    break;
                case 'DisciplineFeedbackAllowed':
                    if (!validateRequiredParamsForRoutment({ id: notificationData?.discipline_id }))
                        return;
                    handleDisciplineFeedbackNavigation(notificationData.discipline_id, !notificationData.read_at);
                    break;
            }
        };
        const markNotificationAsRead = (notificationId, notificationReadAt) => {
            const notificationIDS = notificationId ? [notificationId]
                : notificationsData.value.filter((notification) => !notification?.read_at)
                    .map((notification) => notification.id);
            if (notificationIDS.length > 0 && !notificationReadAt) {
                store.dispatch('markNotificationAsRead', { ids: notificationIDS });
            }
        };
        const handleNotificationPage = (action) => {
            let newPage = null;
            if (action === 'increment') {
                if (notificationsData.value.length >= 6) {
                    newPage = notificationPage.value + 1;
                }
            }
            else {
                if (notificationPage.value > 1) {
                    newPage = notificationPage.value - 1;
                }
            }
            newPage && (store.dispatch('setNotificationsPage', newPage));
        };
        const requestNotificationsData = () => {
            store.dispatch('getNotificationsData', { page: notificationPage.value, perPage: 6, sort: 'created_at|desc' });
        };
        const calculateNotificationCardPosition = () => {
            if (!bellIcon.value)
                return;
            let notificationSectionWidth = 0;
            const bellIconPosition = bellIcon.value.getBoundingClientRect();
            if (props.renderedInSidebar && screenWidth.value < 600) {
                const sideGap = 20;
                notificationSectionWidth = screenWidth.value - (sideGap * 2);
                const rightPosition = screenWidth.value - bellIconPosition.right;
                notificationListStyles.value = { right: `-${rightPosition - sideGap}px` };
            }
            else {
                const iconInRightScreenSide = bellIconPosition.left > (screenWidth.value / 2);
                notificationListStyles.value = iconInRightScreenSide ? { right: '0px' } : { left: '0px' };
                notificationSectionWidth = getNotificationListDefaultWidth();
                const gapFromBorder = 20;
                if (iconInRightScreenSide) {
                    if (bellIconPosition.right - notificationSectionWidth < gapFromBorder) {
                        notificationSectionWidth = bellIconPosition.right - gapFromBorder;
                    }
                }
                else {
                    if (bellIconPosition.left + notificationSectionWidth > (screenWidth.value - gapFromBorder)) {
                        notificationSectionWidth = screenWidth.value - (bellIconPosition.left + gapFromBorder);
                    }
                }
            }
            notificationListStyles.value = {
                ...notificationListStyles.value,
                width: `${notificationSectionWidth}px`,
                [!props.renderedInSidebar ? 'top' : 'bottom']: '100%'
            };
        };
        const getNotificationListDefaultWidth = () => {
            if (screenWidth.value > 900) {
                return 700;
            }
            else if (screenWidth.value <= 900 && screenWidth.value > 600) {
                return 500;
            }
            else if (screenWidth.value <= 600 && screenWidth.value > 500) {
                return 400;
            }
            else {
                return 300;
            }
        };
        watch(screenWidth, () => {
            calculateNotificationCardPosition();
        });
        watch(activeSelectName, (newValue) => {
            if (notificationListState.value && newValue !== 'notificationList') {
                handleNotificationListState();
            }
        });
        watch(notificationPage, () => {
            requestNotificationsData();
        });
        onMounted(() => {
            calculateNotificationCardPosition();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", _hoisted_2, [
                    _createElementVNode("div", {
                        ref_key: "bellIcon",
                        ref: bellIcon,
                        onClick: handleNotificationListState,
                        class: "bell-icon position-relative"
                    }, [
                        _createVNode(NotificationSVG, { renderedInSidebar: __props.renderedInSidebar }, null, 8, ["renderedInSidebar"]),
                        (unreadNotificationsAmount.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                            : _createCommentVNode("", true)
                    ], 512)
                ]),
                _createVNode(_Transition, {
                    name: __props.renderedInSidebar ? 'slide-up-down' : 'no-transition'
                }, {
                    default: _withCtx(() => [
                        (notificationListState.value)
                            ? (_openBlock(), _createElementBlock("section", {
                                key: 0,
                                style: _normalizeStyle(notificationListStyles.value),
                                class: "z-3 text-transition bg-white py-2 shadow position-absolute notification-list"
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-dark mb-0 fw-bold" }, "Notificações", -1)),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("button", {
                                            onClick: _cache[0] || (_cache[0] = ($event) => (markNotificationAsRead(null, null))),
                                            class: "check-all-button border-0 bg-transparent"
                                        }, [...(_cache[3] || (_cache[3] = [
                                                _createElementVNode("i", { class: "cursor-pointer fs-5 bi bi-check2-all" }, null, -1)
                                            ]))]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("button", {
                                                onClick: _cache[1] || (_cache[1] = ($event) => (handleNotificationPage('decrement'))),
                                                class: _normalizeClass([notificationPage.value <= 1 && ('opacity-50'), 'decrement-page-button text-transition border-0 bg-transparent'])
                                            }, [...(_cache[4] || (_cache[4] = [
                                                    _createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1)
                                                ]))], 2),
                                            _createElementVNode("button", {
                                                onClick: _cache[2] || (_cache[2] = ($event) => (handleNotificationPage('increment'))),
                                                class: _normalizeClass([notificationsData.value.length < 6 && ('opacity-50'), 'increment-page-button text-transition border-0 bg-transparent'])
                                            }, [...(_cache[5] || (_cache[5] = [
                                                    _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1)
                                                ]))], 2)
                                        ])
                                    ])
                                ]),
                                (Array.isArray(notificationsData.value) && notificationsData.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notificationsData.value, (notification) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: notification.id,
                                                class: _normalizeClass([notification?.read_at && ('read-notification'), `notification-${notification.id}`, 'text-transition cursor-pointer px-3 py-2 d-flex align-items-center gap-3']),
                                                onClick: ($event) => (handleNotificationAction(notification))
                                            }, [
                                                _createElementVNode("i", {
                                                    class: _normalizeClass([notification?.read_at ? 'bi-bell' : 'bi-bell-fill cursor-pointer', 'bi cursor-pointer fs-5'])
                                                }, null, 2),
                                                _createElementVNode("p", {
                                                    class: "notification-name text-dark flex-grow-1 mb-0",
                                                    innerHTML: notification?.title || 'Título Notificação'
                                                }, null, 8, _hoisted_9),
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("p", _hoisted_11, _toDisplayString(notification?.created_at ? notification?.created_at.slice(0, 10) : 'Data Notificação'), 1),
                                                    _createElementVNode("p", _hoisted_12, _toDisplayString(notification?.created_at ? `${notification?.created_at.slice(10, -3)}h` : 'Horário Notificação'), 1)
                                                ])
                                            ], 10, _hoisted_8));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_13, "Nenhuma notificação encontrada"))
                            ], 4))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["name"])
            ]));
        };
    }
});
